import { Flex, Thead, Tbody, Tr, Th, Table } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { Decimal } from "@syla/shared/decimal";
import { AssetType } from "@syla/shared/types/models/AssetBase";
import React from "react";

import { sortAssetHoldings } from "../../../helper/wallet/sortAssetHoldings";

import { AssetHolding } from "../../../types/wallet/wallet";
import { ContentContainer } from "../../atoms/Containers";
import { EmptyDataMessage } from "../../atoms/EmptyDataMessage";
import { SectionHeading } from "../../atoms/Headings";
import { HoldingTableRow } from "./HoldingTableRow";

export const HoldingTable = ({
  holdings,
  isLoading,
}: {
  holdings?: AssetHolding[];
  isLoading: boolean;
}): JSX.Element => (
  <ContentContainer display="flex" flexDirection="column">
    <Flex
      direction="row"
      alignItems="baseline"
      justifyContent="space-between"
      pr="30px"
    >
      <SectionHeading>Holdings</SectionHeading>
    </Flex>
    <Flex overflowX="auto">
      <Table position="relative" flex={1}>
        <Thead h="38px" position="sticky" top="0">
          <Tr>
            <TableHeaderCell>
              <MergeLeftFlex>Asset</MergeLeftFlex>
            </TableHeaderCell>
            <TableHeaderCell>
              <MergeLeftFlex>Balance</MergeLeftFlex>
            </TableHeaderCell>
            <TableHeaderCell>
              <MergeRightFlex>Cost</MergeRightFlex>
            </TableHeaderCell>
            <TableHeaderCell>
              <MergeRightFlex>Value</MergeRightFlex>
            </TableHeaderCell>
            <TableHeaderCell>
              <MergeRightFlex>Unrealised Gain</MergeRightFlex>
            </TableHeaderCell>
            <TableHeaderCell>
              <MergeRightFlex>Roi</MergeRightFlex>
            </TableHeaderCell>
          </Tr>
        </Thead>
        <Tbody>
          {!holdings || isLoading
            ? [...Array(4)].map((_, idx) => (
                <HoldingTableRow
                  isLoading={true}
                  key={idx}
                  holding={{
                    asset: {
                      _id: "1",
                      code: "DOGE",
                      name: "DogeCoin",
                      type: AssetType.Custom,
                    },
                    balance: Decimal.from("1000"),
                    cost: Decimal.from("10000"),
                  }}
                />
              ))
            : sortAssetHoldings(holdings).map((holding) => (
                <HoldingTableRow
                  key={holding.asset._id}
                  holding={holding}
                  isLoading={isLoading}
                />
              ))}
        </Tbody>
      </Table>
    </Flex>
    {holdings && holdings.length === 0 && !isLoading && (
      <Flex justifyContent="center" alignItems="center" h="100%">
        <EmptyDataMessage content="Add a data source to see your holdings" />
      </Flex>
    )}
  </ContentContainer>
);

const TableHeaderCell = styled(Th)`
  padding: 0;
  background-color: #fff;
`;

const MergeLeftFlex = styled(Flex)`
  width: 100%;
  height: 100%;
  align-items: center;
  font-size: 0.75rem;
  font-weight: bold;
  color: #666;
  padding: 10px 0 10px 24px;
  border-width: 1px 0 1px 0;
  border-color: #f5f5f5;
  white-space: nowrap;
`;
const MergeRightFlex = styled(Flex)`
  width: 100%;
  height: 100%;
  align-items: center;
  font-size: 0.75rem;
  font-weight: bold;
  color: #666;
  justify-content: flex-end;
  padding: 10px 26px 10px 0;
  border-width: 1px 0 1px 0;
  border-color: #f5f5f5;
  white-space: nowrap;
`;
